import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import AudienceSearch from "@/pages/AudienceSearch";
import BatchDetail from "@/pages/BatchDetail";
import BulkUpload from "@/pages/BulkUpload";
import SearchHistory from "@/pages/SearchHistory";
import CampaignBuilder from "@/pages/CampaignBuilder";
import CampaignsList from "@/pages/CampaignsList";
import CampaignDetail from "@/pages/CampaignDetail";
import Reports from "@/pages/Reports";
import IntegrationLogs from "@/pages/IntegrationLogs";
import UsersAdmin from "@/pages/UsersAdmin";
import Advertisers from "@/pages/Advertisers";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          position="top-right"
          theme="light"
          toastOptions={{
            style: {
              fontFamily: "IBM Plex Mono, ui-monospace, monospace",
              border: "1px solid #E0E0D8",
              borderRadius: 0,
              background: "#FFFFFF",
              color: "#0A0A0A",
            },
          }}
        />
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/search" element={<AudienceSearch />} />
            <Route path="/audiences/:id" element={<BatchDetail />} />
            <Route path="/upload" element={<BulkUpload />} />
            <Route path="/history" element={<SearchHistory />} />
            <Route
              path="/campaigns/new"
              element={<ProtectedRoute roles={["admin", "campaign_manager"]}><CampaignBuilder /></ProtectedRoute>}
            />
            <Route
              path="/campaigns"
              element={<ProtectedRoute roles={["admin", "campaign_manager"]}><CampaignsList /></ProtectedRoute>}
            />
            <Route
              path="/campaigns/:id"
              element={<ProtectedRoute roles={["admin", "campaign_manager"]}><CampaignDetail /></ProtectedRoute>}
            />
            <Route path="/reports" element={<Reports />} />
            <Route path="/advertisers" element={<Advertisers />} />
            <Route path="/logs" element={<IntegrationLogs />} />
            <Route
              path="/users"
              element={<ProtectedRoute roles={["admin"]}><UsersAdmin /></ProtectedRoute>}
            />
            <Route index element={<Navigate to="/dashboard" replace />} />
          </Route>

          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
